/**
 * Blok tanda tangan bersama untuk semua cetakan.
 *
 * Nama pejabat tetap dibaca LANGSUNG dari master perusahaan, bukan dari
 * salinan beku `company_data` di dokumen: yang bertanda tangan hari ini adalah
 * pejabat hari ini, termasuk saat dokumen lama dicetak ulang. Alamat dan NPWP
 * justru sebaliknya — tetap beku sebagai catatan sah saat transaksi.
 */
import { escapeHtml } from './printHelper';

/** Cari perusahaan di master berdasarkan id dokumen. */
export function findCompany(companies, companyId) {
  return (companies || []).find((c) => c.id === companyId) || null;
}

/**
 * Ambil satu slot penanda tangan dari master.
 * `slot` salah satu: 'fat' | 'gm' | 'finance' | 'pemeriksa'.
 * Mengembalikan { nama, jabatan } — keduanya bisa kosong.
 */
export function signatory(company, slot) {
  if (!company) return { nama: '', jabatan: '' };
  return {
    nama: (company[`ttd_${slot}_nama`] || '').trim(),
    jabatan: (company[`ttd_${slot}_jabatan`] || '').trim(),
  };
}

/**
 * Satu kotak tanda tangan.
 *
 * Garisnya digambar oleh `border-top` pada `.signature-line`; isinya nama saja.
 * Template lama menaruh `________________` DI ATAS garis itu sehingga tercetak
 * dua garis — jangan diulang.
 *
 * @param title  judul kolom, mis. "DIBUAT OLEH"
 * @param nama   nama yang tercetak di atas garis (boleh kosong)
 * @param jabatan teks kecil di bawah garis (boleh kosong)
 */
export function signatureBox(title, nama = '', jabatan = '') {
  const bawah = jabatan
    ? `<div class="signature-role">${escapeHtml(jabatan)}</div>`
    : '';
  return `<div class="signature">
      <p>${escapeHtml(title)}</p>
      <div class="signature-line">${escapeHtml(nama) || '&nbsp;'}</div>
      ${bawah}
    </div>`;
}

/** Rangkai beberapa kotak menjadi satu baris tanda tangan. */
export function signatureRow(boxes) {
  return `<div class="footer">${boxes.join('')}</div>`;
}

/** Gaya bersama — dipakai semua cetakan supaya bentuknya seragam. */
export const SIGNATURE_STYLE = `
  .footer { display: flex; justify-content: space-around; margin-top: 28px; }
  .signature { width: 170px; text-align: center; }
  .signature p { margin-bottom: 46px; font-weight: bold; font-size: 9pt; }
  .signature-line { border-top: 1px solid #000; padding-top: 4px; font-size: 9pt; }
  .signature-role { font-size: 8pt; color: #444; margin-top: 2px; }
`;
